import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { getLogger } from '@/idv2/utils/logger';
import { getBackQueryKey, getProceedQueryKey } from '@/idv2/utils/proceed-query';
import { setIdv2StoreData } from './idv2-provider';
const {
  logInfo
} = getLogger({
  name: 'idv2',
  location: 'use-navigation'
});

/**
 * Navigation hook to trigger IDV2 route re-evaluation.
 * Sets navigation direction and relayToIDV2 so IDV2 knows which API to call.
 */
export const useNavigation = () => {
  const $ = _c(7);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = async () => {
      await queryClient.invalidateQueries({
        type: "all",
        queryKey: getProceedQueryKey(),
        refetchType: "none"
      });
      setIdv2StoreData({
        navigation: "forward",
        relayToIDV2: true
      });
      logInfo("Idv to idv2 navigation forward", {
        relayToIDV2: true
      });
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const forward = t0;
  let t1;
  if ($[2] !== queryClient) {
    t1 = async () => {
      await queryClient.invalidateQueries({
        type: "all",
        queryKey: getBackQueryKey(),
        refetchType: "none"
      });
      setIdv2StoreData({
        navigation: "back",
        relayToIDV2: true
      });
      logInfo("Idv to idv2 navigation back", {
        relayToIDV2: true
      });
    };
    $[2] = queryClient;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const back = t1;
  let t2;
  if ($[4] !== back || $[5] !== forward) {
    t2 = {
      forward,
      back
    };
    $[4] = back;
    $[5] = forward;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};